const organizations = ['US', 'CA'];

class ImportValidator {
  // eslint-disable-next-line class-methods-use-this
  validateOrganization = (organization) => {
    return organization !== null
      && organizations.indexOf(organization?.toUpperCase()) > -1
      ? organizations[organizations.indexOf(organization?.toUpperCase())]
      : organizations[0];
  };
}

export default new ImportValidator();
